// @ts-nocheck
/* eslint-enable */
// App
import React, { useState } from 'react';

// Misc / utils
import * as S from './styles';

const CommuteAutocompleteItem = ({ item, customRef, handleSelectionClick, handleSelectionKeyDown }) => {
  // React
  const [isFocused, setIsFocused] = useState(false);

  const handleClick = () => handleSelectionClick(item);
  const handleKeyDown = (e) => handleSelectionKeyDown(e, item);
  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);

  return (
    <S.Li
      aria-selected={isFocused}
      onBlur={handleBlur}
      onClick={handleClick}
      onFocus={handleFocus}
      onKeyDown={handleKeyDown}
      ref={customRef}
      role="option"
      tabIndex="0"
    >
      <S.SuggestionPrimaryText>{item.primaryText}</S.SuggestionPrimaryText>
      <S.SuggestionSecondaryText>{item.secondaryText}</S.SuggestionSecondaryText>
    </S.Li>
  );
};

export default CommuteAutocompleteItem;
